export default __webpack_public_path__ + "static/media/ClockWorkflow.b5af1df0.svg";